<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        Bloco Cirúrgico
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-tabs background-color="transparent" color="gray">
          <authorization
            permissionKey="surgery_ward_reception_queue"
            can="read"
          >
            <v-tab
              to="/filas/bloco-cirurgico/recepcao"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Recepção Cirúrgica"
                queueType="surgery_reception"
              />
            </v-tab>
          </authorization>

          <authorization
            permissionKey="surgery_ward_preoperative_queue"
            can="read"
          >
            <v-tab
              to="/filas/bloco-cirurgico/pre-operatorio"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Pré-operatório"
                queueType="surgery_preoperative"
              />
            </v-tab>
          </authorization>

          <authorization
            permissionKey="surgery_ward_intraoperative_queue"
            can="read"
          >
            <v-tab
              to="/filas/bloco-cirurgico/intra-operatorio"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Intra-operatório"
                queueType="surgery_intraoperative"
              />
            </v-tab>
          </authorization>

          <authorization
            permissionKey="surgery_ward_postoperative_queue"
            can="read"
          >
            <v-tab
              to="/filas/bloco-cirurgico/pos-operatorio"
              class="font-weight-bold"
            >
              <PatientsCounter
                queueTitle="Pós-operatório"
                queueType="surgery_postoperative"
              />
            </v-tab>
          </authorization>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";
export default {
  name: "SurgicalWard",
  components: {
    PatientsCounter,
  },
};
</script>

<style lang="sass" scoped></style>
